

<template>
    <div class="dus-container bg-black pb-lg-80 pb-60 pt-lg-40 pt-24 cp-home-hero">
        <div class="big-title mb-lg-56 mb-26">
            <h1>{{ $t('home.hero.title') }}</h1>
            <p>{{ $t('home.hero.description') }}</p>
        </div>
        <div class="grid-container"   >
            <HeroCard
                v-for="item in list"
                :key="item.hovering"
                :item="item"
            />
        </div>

        <div class="card-six">
            <div class="icon-text">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" style=" height: 60px; width: 60px;"><defs></defs><g id="Picto"><path style="fill: white;" d="M12,45.11v-26H48v26Zm3.36-1.87H44.61l-8.54-8.45,1.48-1.3,8.5,8.45V22.45A106.64,106.64,0,0,1,30.69,34.5H29.25a106.09,106.09,0,0,1-15.36-12V41.94l8.49-8.45,1.49,1.3ZM30,32.58A104.29,104.29,0,0,0,44.75,21H15.18A104.1,104.1,0,0,0,30,32.58Z"/></g></svg>
                <h4 class="-desktop">{{ $t('home.hero.cards.newsletter.title') }}</h4>
                <h4 class="-mobile">{{ $t('home.hero.cards.newsletter.title') }}</h4>
            </div>
            <RenaultButton :text="$t('home.hero.cards.newsletter.button')" is-anchor is-white href="/newsletter"/>
            <a href="/newsletter" target="_self" class="link-mobile">
                <svg class="icon">
                    <use xlink:href="#icon-arrow-right1"></use>
                </svg>
            </a>
        </div>

    </div>
</template>


<script>
import HeroCard from './HeroCard.vue';
import RenaultButton from '../Shared/RenaultButton.vue';

export default {
    components: {
        HeroCard,
        RenaultButton
    },
    data() {
        return {
            list: [
                {
                    title: this.$t('home.hero.cards.1.title'),
                    description: this.$t('home.hero.cards.1.description'),
                    image: require('../../../images/home/heroattestations.webp'),
                    hovering: 1,
                    link: '/attestation-certificat',
                },
                {
                    title: this.$t('home.hero.cards.2.title'),
                    description: this.$t('home.hero.cards.2.description'),
                    image: require('../../../images/home/store.webp'),
                    hovering: 2,
                    link: '/store',
                },
                {
                    title: this.$t('home.hero.cards.3.title'),
                    description: this.$t('home.hero.cards.3.description'),
                    image: require('../../../images/home/squareparts.webp'),
                    hovering: 3,
                    link: '/partners',
                },
                {
                    title: this.$t('home.hero.cards.4.title'),
                    description: this.$t('home.hero.cards.4.description'),
                    image: require('../../../images/home/manuel.webp'),
                    hovering: 4,
                    link: '/manuals',
                },
                {
                    title: this.$t('home.hero.cards.5.title'),
                    description: this.$t('home.hero.cards.5.description'),
                    image: require('../../../images/home/tutos.webp'),
                    hovering: 5,
                    link: '/videos',
                },
            ],
        };
    },
};
</script>